import React from 'react';

const Error500 = () => {
  return <div>Error500</div>;
};

Error500.propTypes = {};

export default Error500;
